import React from "react";

const RadioInput = ({ value, checked, onChange, setValue }) => {
    const onChangeHandler = (e) =>{
        onChange(e.target.innerText);
        setValue(e.target.innerText);
    }
    const onClickHandler = (e) => {
        onChange(e.target.innerText);
        setValue(e.target.innerText);
    }
    return (
        <div className="p-[8px] flex items-center radio-modal relative" >
            <input type="radio" checked={checked}  value={value} 
                onChange={onChangeHandler}/> 
            <label 
                htmlFor={value}
                value={value} onClick={onClickHandler} 
                data-testid={`${value.replace(' ', '')}-btn`}
                className="text-base font-normal pl-[18px] cursor-pointer !text-[#1F1F1F]">
                {value}
            </label>
        </div>
    )
};
  
export default RadioInput;